module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAM1JREFUeNpiYMAFGEGEh4eHA4gGCCAQ4z+qNEwKIIAYsUpjAwABhNUgkDkNQLoeJrBjxw5GrOYxYXUl3IUI8AEggBiRtYPNI8VFaHICRCnE60icwYtkcgGQuoAkVA90tyOIARBAsPBVAFL38XmIaF8TE2ONQAMaUL1PYtBhVUh08FBfIQtKesYOHFFiBqh4PygokBQYAINlAowDEGBDBIAiERT+0IxGqt4GrJFMfIbHn2qYqO3bwW8gKJ++B9ICVDLvA9VTDCMleR1byQMAItRG9lYUgEQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icon/web-url.png
// module id = Wfhm
// module chunks = 1